import script from "./LandlordProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./LandlordProfileView.vue?vue&type=script&setup=true&lang=js"

import "./LandlordProfileView.vue?vue&type=style&index=0&id=598700ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598700ee"]])

export default __exports__